import './DuplicateAd.scss';

import { IconCopy } from '@hulu-react-style-components/icons';
import React, { memo, useCallback } from 'react';

import Button from '../../../common/Button';
import Tooltip from '../../../common/Tooltip';
import bem from '../../../utils/bem';
import type { TraffickingPageDrawerData } from '../TraffickingPage/hooks/makePageDrawerPlugin';
import { DrawerType } from '../TraffickingPage/hooks/makePageDrawerPlugin';
import type { AdModel, LineItemModel } from '../TraffickingPage/modelConverters';
import { TOOLTIP_MESSAGE } from './constants';
import { arePropsEqual } from './utils';

const [block, element] = bem('duplicate-ad-button');

export interface DuplicateAdProps {
  selectedAds: AdModel[];
  selectedLineItems: LineItemModel[];
  isDisabled: boolean;
  openTraffickingPageDrawer: (data: TraffickingPageDrawerData) => void;
}

const DuplicateAd = ({
  selectedAds,
  selectedLineItems,
  isDisabled,
  openTraffickingPageDrawer,
}: DuplicateAdProps): JSX.Element => {
  const handleOpenDuplicateDrawer = useCallback((): void => {
    if (isDisabled || !selectedAds.length) return;

    openTraffickingPageDrawer({
      drawerType: DrawerType.MULTIPLE_DUPLICATE,
      selectedAds: selectedAds,
      selectedLineItems: selectedLineItems,
    });
  }, [isDisabled, selectedAds, openTraffickingPageDrawer, selectedLineItems]);

  return (
    <>
      <Tooltip id="duplicate-ad" className={element('tooltip')} message={TOOLTIP_MESSAGE} disable={!isDisabled}>
        <Button
          size="medium"
          variant="outlined"
          className={block()}
          disabled={isDisabled}
          aria-label="Copy Ad(s) to Line Items"
          icon={<IconCopy />}
          onClick={handleOpenDuplicateDrawer}
          data-testid="duplicate-ad-button"
        >
          Copy Ad(s) to Line Items
        </Button>
      </Tooltip>
    </>
  );
};

export default memo(DuplicateAd, arePropsEqual);
